import { Link } from "react-router-dom";
import { LuMapPin, LuCalendarDays, LuChevronRight } from "react-icons/lu";
import { dateValue, safeUrl } from "../utils/appData";

const day = (value) => {
  if (!value) return "";
  const d = new Date(value);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      ...(d.getFullYear() !== new Date().getFullYear()
        ? { year: "numeric" }
        : {}),
    });
};
export function jobWhen(job) {
  const start = day(job.workStart),
    end = day(job.workEnd);
  if (start || end)
    return start && end && start !== end ? `${start} to ${end}` : start || end;
  const deadline = day(job.deadline || job.neededBy);
  return deadline
    ? `By ${deadline}`
    : job.datesFlexible
      ? "Dates flexible"
      : "";
}
export function timeAgo(value) {
  if (!dateValue(value)) return "";
  const minutes = Math.max(
    0,
    Math.floor((Date.now() - dateValue(value)) / 60000),
  );
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (minutes < 1440) return `${Math.floor(minutes / 60)}h ago`;
  return `${Math.floor(minutes / 1440)}d ago`;
}
export default function JobCard({ job, matched = false, owned = false }) {
  const company = job.companyName || job.hostName || "";
  const image = safeUrl(job.imageUrl) || safeUrl(job.hostProfilePic);
  const when = jobWhen(job);
  const initial = (company || job.title || "Z").slice(0, 1).toUpperCase();
  const status =
    job.approvalStatus === "pending"
      ? "Awaiting approval"
      : job.approvalStatus === "rejected"
        ? "Rejected"
        : job.status;
  return (
    <Link
      className="mb-2.5 block min-w-0 rounded-[18px] border border-black/[0.06] bg-white px-3.5 pt-3 pb-[11px] text-[#1d1d1f] shadow-[0_1px_2px_#0000000a] dark:border-[#363e46] dark:bg-[#23272c] dark:text-[#f5f5f7]"
      to={`/jobs/${job.id}`}
    >
      <div className="flex items-start gap-3">
        <div
          className="relative grid h-11 w-11 shrink-0 place-items-center overflow-hidden rounded-xl bg-gradient-to-br from-[#5e9bb2] to-[#24596e] text-xl font-bold text-white [&>img]:absolute [&>img]:inset-0 [&>img]:h-full [&>img]:w-full [&>img]:object-cover"
          aria-hidden="true"
        >
          <span>{initial}</span>
          {image && (
            <img
              src={image}
              alt=""
              loading="lazy"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          )}
        </div>
        <div className="min-w-0 flex-1 [&>h3]:truncate [&>h3]:text-[15.5px] [&>h3]:font-bold [&>h3]:leading-5 [&>h3]:tracking-[-0.2px] [&>p]:mt-0.5 [&>p]:truncate [&>p]:text-[12.5px] [&>p]:leading-[17px] [&>p]:text-[#6e6e73] dark:[&>p]:text-[#9a9aa1]">
          <h3>{job.title}</h3>
          <p>{company}</p>
          {matched && (
            <span className="mt-[9px] inline-block rounded-md bg-[#edf3f5] px-2 text-[10.5px] font-bold leading-5 text-[#327691] dark:bg-[#22333a] dark:text-[#5FAFCB]">
              MATCHES YOU
            </span>
          )}
        </div>
        {owned ? (
          <span className="max-w-[95px] rounded-[7px] bg-[#edf3f5] px-[7px] py-1 text-[10px] text-[#327691] dark:bg-[#22333a] dark:text-[#5FAFCB]">
            {status}
          </span>
        ) : (
          <LuChevronRight
            className="mt-[3px] shrink-0 text-[#aeaeb2]"
            size={17}
          />
        )}
      </div>
      {when && (
        <div className="mt-2.5 flex w-fit items-center gap-[5px] rounded-md bg-[#edf3f5] px-[7px] py-1 text-[11.5px] font-semibold text-[#327691] dark:bg-[#22333a] dark:text-[#5FAFCB]">
          <LuCalendarDays size={13} />
          {when}
        </div>
      )}
      <div className="mt-[11px] flex flex-wrap items-center justify-between gap-2.5 border-t border-black/[0.06] pt-2.5 dark:border-white/[0.09] [&>span]:flex [&>span]:min-w-0 [&>span]:items-center [&>span]:gap-1 [&>span]:text-xs [&>span]:text-[#6e6e73] dark:[&>span]:text-[#9a9aa1] [&>strong]:ml-auto [&>strong]:text-sm [&>strong]:font-bold [&>strong]:text-[#1e7f4f] dark:[&>strong]:text-[#3fbf7f]">
        <span>
          <LuMapPin size={13} />
          {[job.location, timeAgo(job.createdAt)].filter(Boolean).join(" · ")}
        </span>
        <strong>
          {job.payRate}
          {job.rateUnit && !String(job.payRate).includes("/")
            ? ` / ${job.rateUnit}`
            : ""}
        </strong>
      </div>
    </Link>
  );
}
